// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listview-root{height:100%}`, "",{"version":3,"sources":["webpack://./src/EmploymentBillboard/App/EmployeeDashboard/Desktop/BillboardListView/BillboardListView.scss"],"names":[],"mappings":"AAAA,eACI,WAAA","sourcesContent":[".listview-root {\r\n    height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
